module.exports = __webpack_public_path__ + "img/chickenSalad.7179e1ea.png";